import { useQuery } from "@tanstack/react-query";
import { faCirclePlus, faEllipsisH, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { DateRange } from '../../../../../components/common/DateRange';

import EstimateModal from "../Modal/EstimateModal";


interface GameBoxProps {
  game: OngoingGame;
}

interface OngoingGame {
  gameProposalId: number;
  gameId: number;
  title: string;
  bannerUrl: string;
  startedAt: string;
  expiredAt: string;
}

const GameBoxContainer = styled.div`
  position: relative;
`;

const ContentBox = styled.div`
  border-radius: 5px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
  min-width: 300px;
  flex-shrink: 0;
`;

const GameBox = styled(ContentBox)`
  flex-direction: column;
  padding: 20px;
  justify-content: flex-end;
  align-items: flex-start;
  position: relative;
  background-color: white;
  // height: 0vh;
  // height: 400px;
`;


const BannerImage = styled.div<{ url: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 220px;
  background-image: 
    linear-gradient(180deg, rgba(255,255,255,0) 70%, rgba(255,255,255,1) 100%),
    ${({ url }) => `url(${url})`};
  background-size: cover;
  background-position: center;
  border-radius: 5px 5px 0 0;
`;

const GameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 230px;
  background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0) 100%);
  border-radius: 5px 5px 0 0;
`;

const DefaultBanner = styled.div`
  position: absolute;
  top: 0%;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(180deg, #E7E7E7 0%, #FEFEFE 100%);
  border-radius: 5px 5px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;
`;

const DefaultText = styled.p`
  font-size: 15px;
  color: #999;
  margin: 0 0 0 0;
`;
const MoreButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: none;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #666666;
  z-index: 2;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

const DropdownMenu = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 50px;
  right: -30px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  z-index: 3;
`;

const MenuItem = styled.button`
  padding: 15% 20px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #555555;
  cursor: pointer;
  width: 100%;
  display: block;
 border-radius: 8px;
  &:hover {
    background-color: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

const ContentInfo = styled.div`
  padding-top: 30px;
  margin-top: auto;
  height:42%;
  width: 100%;
`;

const GameTitle = styled.h3`
  color: black;
  font-size: 18px;
  font-weight: 600;
  z-index: 1;
  margin: 0 0 12px 0;
  position: relative;
  margin-top: 10px;
  padding-top: 20px;
  // padding-bottom: 20px;
`;

const GameDate = styled.p`
  color: #666666;
  font-size: 14px;
  margin: 0 0 12px 0;
  margin-top: 10px;
  z-index: 1;
    position: relative;
`;

// 기존 컴포넌트에 모달 상태 추가
export default function ExpiredGameBox({ game }: GameBoxProps) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isEstimateModalOpen, setIsEstimateModalOpen] = useState(false);

  // 드롭다운 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isDropdownVisible) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDropdownVisible]);

  const handleEstimateClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDropdownVisible(false);
    setIsEstimateModalOpen(true);
  };

  return (
    <GameBoxContainer>
      <GameBox>
        {game.bannerUrl && game.bannerUrl !== "" ? (
          <>
            <BannerImage url={game.bannerUrl} />
            <GameOverlay />
          </>
        ) : (
          <DefaultBanner>
            <DefaultText>이미지 등록 필요.</DefaultText>
          </DefaultBanner>
        )}
        <GameOverlay />
        <MoreButton
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            setIsDropdownVisible(!isDropdownVisible);
          }}
        >
          <FontAwesomeIcon icon={faEllipsisH} />
        </MoreButton>
        <DropdownMenu isVisible={isDropdownVisible}>
          <MenuItem onClick={handleEstimateClick}>
            테스트 견적서 확인
          </MenuItem>
        </DropdownMenu>
        <div style={{ marginTop: 'auto', width: '100%', height: '30%' }}>
          <GameTitle>{game.title}</GameTitle>
          <GameDate>
            <DateRange startDate={game.startedAt} endDate={game.expiredAt} />
          </GameDate>
        </div>
      </GameBox>

      {/* 견적서 모달 */}
      <EstimateModal
        isOpen={isEstimateModalOpen}
        onClose={() => setIsEstimateModalOpen(false)}
        gameProposalId={game.gameProposalId}
      />
    </GameBoxContainer>
  );
};
